interface Props {
  title: string;
  description?: string;
  screenNo?: string;
}

export function Placeholder({ title, description, screenNo }: Props): JSX.Element {
  return (
    <div className="page-placeholder">
      <h1>{title}</h1>
      {screenNo && <div>화면 {screenNo} — 준비 중</div>}
      {description && <p>{description}</p>}
    </div>
  );
}
